import React, { Component } from 'react'
import '../../../App.css';
import './index.css';
import { Layout, List, Button, Avatar } from 'antd';
import iconVerison from '../../../assets/images/icon/icon-verison.png'
import http from '../../../utils/axios'
import { VERSION_URL } from '../../../utils/url'
import { withTranslation } from 'react-i18next';
const { Content, Sider } = Layout;
class VersionInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            newVersion: {}
        }
        this.tabCheck = this.tabCheck.bind(this);
        this.getVersionList = this.getVersionList.bind(this)
    }
    getMyDate(str) {
        var oDate = new Date(str),
            oYear = oDate.getFullYear(),
            oMonth = oDate.getMonth() + 1,
            oDay = oDate.getDate(),
            oHour = oDate.getHours(),
            oMin = oDate.getMinutes(),
            oSen = oDate.getSeconds(),
            oTime = oYear + '-' + this.addZero(oMonth) + '-' + this.addZero(oDay) + ' ' + this.addZero(oHour) + ':' +
                this.addZero(oMin) + ':' + this.addZero(oSen);
        return oTime;
    };
    addZero(num) {
        if (parseInt(num) < 10) {
            num = '0' + num;
        }
        return num;
    };
    tabCheck(event, versionName) {
        event.preventDefault();
        let list = this.state.data.filter(item => {
            return item.versionName === versionName
        })
        this.setState({
            newVersion: list[0]
        })
    }
    async getVersionList() {
        const res = await http.get(VERSION_URL);
        if (res.data.flag === 'Y') {
            res.data.result = res.data.result.map(item => {
                item.createtime = this.getMyDate(item.createtime);
                return item
            })
            this.setState({
                data: res.data.result,
                newVersion: res.data.result[0]
            })
        }
    }
    componentDidMount() {
        this.getVersionList()
    }
    render() {
        const { t } = this.props;
        return (
            <Content className="q-content-wrapper q-versionInfo">
                <div className="q-main" style={{ minHeight:'780px' }}>
                    <div className="q-fix-width ">
                        <Layout>
                            <Content className="q-version-left">
                                {
                                    this.state.newVersion.versionName ?
                                        <div className="q-version-headline">
                                            <span>{this.state.newVersion.versionName}</span>
                                            <h3>{this.state.newVersion.versionName}{t('ver_info')}</h3>
                                        </div>
                                        :
                                        <div className="q-version-headline">
                                            <span>{t('ver_info_em')}</span>
                                            <h3>{t('ver_info_empty')}</h3>
                                        </div>
                                }

                                <div className="q-version-content">
                                    <List
                                        header={<Button type="add">{t('ver_info_add')}</Button>}
                                        bordered={false}
                                        dataSource={this.state.newVersion.improments}
                                        size="small"
                                        renderItem={item => (<List.Item>{item.itemDesc}</List.Item>)}
                                    />
                                    <List
                                        header={<Button type="opt">{t('ver_info_opt')}</Button>}
                                        bordered={false}
                                        dataSource={this.state.newVersion.newFeatures}
                                        size="small"
                                        renderItem={item => (<List.Item>{item.itemDesc}</List.Item>)}
                                    />
                                </div>
                            </Content>
                            <Sider className="q-version-right" theme="light" style={{ width: '448' }}>
                                <Button type="history">{t('ver_info_history')}</Button>
                                <List
                                    className="q-height-auto"
                                    itemLayout="horizontal"
                                    dataSource={this.state.data}
                                    renderItem={item => (
                                        <List.Item className="q-version-right_list" >
                                            <List.Item.Meta
                                                avatar={<Avatar className="icon icon-verison" src={iconVerison} />}
                                                title={<a href="#" onClick={(event) => this.tabCheck(event, item.versionName)}>{item.versionName}</a>}
                                                description={
                                                    [...item.improments, ...item.newFeatures].map(_item =>
                                                        <p key={_item.itemIndex + Math.random() * 10}>{_item.itemDesc}</p>
                                                    )
                                                }
                                            />
                                            <div>{item.createtime}</div>
                                        </List.Item>
                                    )}
                                />,
                            </Sider>
                        </Layout>
                    </div>
                </div>
            </Content>
        )
    }
}
export default withTranslation()(VersionInfo)